import { render, staticRenderFns } from "./l-image.vue?vue&type=template&id=8569045a&lang=pug&"
import script from "./l-image.vue?vue&type=script&lang=js&"
export * from "./l-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports